import React from "react";
import ErrorFallback from "../error-fallback";

interface NotCriticalErrorProps {
  message?: string;
}

const NotCriticalError: React.FC<NotCriticalErrorProps> = ({ message }) => {
  return <ErrorFallback title={message} showHome showAsNotFound={false} />;
};

export default NotCriticalError;
